import { IPresTruncatedDataDTO } from 'API';
import { useState } from 'react';
import { PrescriptionDialog } from '../PrescriptionDialog';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import {
  useDictionary,
  useIsDesktop,
  usePrescriptionAndUnHandledOrders,
} from 'Hooks';
import { PrescriptionsList } from './PrescriptionsList';
import { sendEvent } from 'Utils/sendEvent';

export const PrescriptionsGrid = () => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  const gridTitles = [
    dictionary.prescriptionCode,
    dictionary.createdDate,
    dictionary.updateDateLabel,
    dictionary.status,
    dictionary.medicationsAmount,
  ];

  const { prescriptionsAndUnHandledOrders } =
    usePrescriptionAndUnHandledOrders();

  prescriptionsAndUnHandledOrders.prescriptions =
    prescriptionsAndUnHandledOrders.prescriptions &&
    prescriptionsAndUnHandledOrders.prescriptions.filter(
      (p) => p.notSupply !== 1
    );
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState<any>();
  const isDesktop = useIsDesktop();

  const handleOpenModal = (p: IPresTruncatedDataDTO) => {
    sendEvent(
      'Medicine',
      isDesktop ? 'WatchStatusOrderDesktop' : 'WatchStatusOrderMobile'
    );
    setSelectedValue(p);
    setOpen(true);
  };
  const handleClose = () => {
    setSelectedValue(undefined);
    setOpen(false);
  };

  return (
    <>
      <PrescriptionsList
        titles={gridTitles}
        items={prescriptionsAndUnHandledOrders}
        onShowPrescriptionDetailsClick={handleOpenModal}
      />
      {open && (
        <PrescriptionDialog
          onClose={handleClose}
          open={open}
          item={selectedValue}
        />
      )}
    </>
  );
};
